/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ClarityIcons, searchIcon } from '@cds/core/icon';

import { ICONS_STATES } from './icon-groups/icon-inventory';

@Component({
  selector: 'app-icon-shapes',
  templateUrl: './icon-shapes.component.html',
  styleUrls: ['./icon-shapes.component.scss'],
})
export class IconShapesComponent {
  iconStates = ICONS_STATES;

  form = new FormGroup({
    searchTerm: new FormControl(''),
    solid: new FormControl(false),
    badge: new FormControl(''),
  });

  constructor() {
    ClarityIcons.addIcons(searchIcon);
  }
}
